import { render, staticRenderFns } from "./SwiperRelatedFormations.vue?vue&type=template&id=79241447&"
import script from "./SwiperRelatedFormations.vue?vue&type=script&lang=js&"
export * from "./SwiperRelatedFormations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports